// extracted by mini-css-extract-plugin
export default {"accordion":"x7VWCXgyFZ1zg5G_PJZR"};